var bLoadingACard=false;

$(function () {
    $(document).on("click", ".btn-close-card", function () {
        event.preventDefault();   
        $('.traveler-card-trigger').dropdown('hide')
    })                         

   
     $(document).on("click", ".btn-delete-traveler", function () {
        event.preventDefault();   
        do_traveler_delete($(this).data("cid"), $(this).data("cname"));
    })   
    init_page_trav_cards();     
    
})

function init_trav_cards(sel) { 
    $(sel + ' .traveler-card-trigger').each(function() {
        var ele = $( "<div class=\"dropdown-menu traveler\"></div>" ).css("min-height","400px").css("min-width","550px")
        $(this).parent().append( ele);
    });

    $('.traveler-card-trigger').on('show.bs.dropdown', function () {
        if (!bLoadingACard) {   //triggers 2x
            bLoadingACard=true;
            showTravelerCard($(this).data('tid'));
        } 
    })
 }

 function showTravelerCard(cid) {
     
    $('.traveler-card-trigger[data-tid]').next().html("");   //empty all old ones
    var DTO = { 'ClientId': cid }       
        
    DynaProxy.invoke("GetTravelerCardDetail", DTO, function (data) {     
       $('.travelers-popover .sections').html(data);  //update modeal
       $('.traveler-card-trigger[data-tid=' + cid + ']').next().html( $('.travelers-popover-menu').html()).addClass('white').find(".travelers-popover").addClass('white');
       bLoadingACard=false;        
    }, function (data) {
            bLoadingACard=false;
        showSystemNotification('Unable to get traveler information.');
    })
}

function init_trip_trav_cards() {init_trav_cards("#triplist");}    
function init_traveler_trav_cards() {init_trav_cards(".travelerlist");}
function init_page_trav_cards(){
    init_trip_trav_cards();
    init_traveler_trav_cards();
}

